const SCOPE = 'loan-exceptions';

export const ExceptionsTestIds = {
  ADD_BUTTON: `${SCOPE}.add-button`,
  TABLE: `${SCOPE}.table`,
  CATEGORY_SELECT: `${SCOPE}.category-select`,
  SUB_CATEGORY_INPUT: `${SCOPE}.sub-category-input`,
  REASON_INPUT: `${SCOPE}.reason-input`,
  JUSTIFICATION_INPUT: `${SCOPE}.justification-input`,
  CURRENT_STATUS_INPUT: `${SCOPE}.current-status-input`,
  AFFECTS_HMDA_CHECKBOX: `${SCOPE}.affects-hmda-checkbox`,
  SUBMIT_BUTTON: `${SCOPE}.submit-button`,
  APPROVE_BUTTON: `${SCOPE}.approve-button`,
  DENY_BUTTON: `${SCOPE}.deny-button`,
  WITHDRAW_BUTTON: `${SCOPE}.withdraw-button`,
  DECISION_NOTES_INPUT: `${SCOPE}.decision-notes-input`,
  WITHDRAW_REASON_INPUT: `${SCOPE}.withdraw-reason-input`,
};
